module.exports = __webpack_public_path__ + "media/images/illustrations/movers_with_tv_small-1e3c24eed1c7f3ad0862e517fd87589f.svg";